import { gsap } from 'gsap'
import { Draggable } from 'gsap/Draggable'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

import dragStuff from './features/drag-stuff.js'

gsap.registerPlugin(ScrollTrigger)

gsap.registerPlugin(Draggable)
dragStuff()

/* const headingWrapper = document.querySelector('.heading-wrapper')
const line = headingWrapper.querySelector('.line-divider')
const lineMarker = headingWrapper.querySelector('.line-marker')
gsap.from(line, {
  delay: 2,
  width: 0,
  opacity: 0.5,
  duration: 1,
  ease: 'power1.out',

  onComplete: () => {
    gsap.to(lineMarker, {
      opacity: 0,
      duration: 0.8,
      ease: 'power2.out',
    })
  },
}) */
gsap.from('.layout1_feature', {
  delay: 2,
  opacity: 0,
  y: 10,
  duration: 0.7,
  ease: 'power2.out',
  stagger: 0.2,
})

// Line Animation and Heading Fade in
let lineWrappers = document.querySelectorAll('.heading-wrapper')

lineWrappers.forEach((item) => {
  const line = item.querySelector('.line-divider')
  const lineMarker = item.querySelector('.line-marker')
  gsap.from(item, {
    opacity: 0,
    y: 10,
    duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: item, // Use the next item as the trigger
      start: 'top 90%',
      /*       toggleActions: 'play reverse play reverse', */
      scrub: false,
    },
  })
  gsap.from(line, {
    width: 0,
    opacity: 0.5,
    duration: 1,
    ease: 'power1.out',
    scrollTrigger: {
      trigger: item, // Use the next item as the trigger
      start: 'top 80%',
      end: 'bottom 0%',
      /*       toggleActions: 'play reverse play reverse', */
      scrub: false,
    },
    onComplete: () => {
      gsap.to(lineMarker, {
        opacity: 0,
        duration: 0.8,
        ease: 'power2.out',
      })
    },
  })
})

// Line Animation and Heading Fade in
let timlineItems = document.querySelectorAll('.timeline3_item')

timlineItems.forEach((item) => {
  const image = item.querySelector('.timeline3_image')
  gsap.from(item, {
    opacity: 0,
    y: 10,
    duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: item, // Use the next item as the trigger
      start: 'top 80%',
    },
  })
  gsap.from(image, {
    scale: 1.1,
    duration: 1,
    ease: 'power1.out',
    scrollTrigger: {
      trigger: item, // Use the next item as the trigger
      start: 'top 80%',
      scrub: 1,
    },
  })
})

let serviceItems = document.querySelectorAll('.layout4_component')

serviceItems.forEach((item) => {
  /*   gsap.from(item, {
    opacity: 0,
    y: 20,
    duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: item,
      start: 'top 60%',
      end: 'bottom 0%',
      scrub: false,
    },
  }) */
  gsap.from(item.querySelector('.layout4_content'), {
    opacity: 0,
    y: 10,
    duration: 1,
    ease: 'power2.out',
    scrollTrigger: {
      trigger: item, // Use the next item as the trigger
      start: 'top 80%',
      /*       toggleActions: 'play reverse play reverse', */
      scrub: false,
    },
  })
})

serviceItems.forEach((component) => {
  // Create the ScrollTrigger animation for the .layout4_image-wrapper
  gsap.fromTo(
    component.querySelector('.layout4_image'),
    { scale: 1.2 },
    {
      scale: 1,
      duration: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: component,
        start: 'top 80%', // Adjust based on when you want the animation to start
        end: 'top 20%', // Adjust based on when you want the animation to end
        scrub: true,
      },
    }
  )
})

const layoutContent = document.querySelectorAll('.layout439_content')
const layoutIllustrations = document.querySelectorAll('.grid-list3_item')
gsap.set(layoutIllustrations, { opacity: 0, y: 0, scale: 0.5, rotate: 10 })

layoutContent.forEach((item) => {
  gsap.from(item, {
    opacity: 0,
    y: 40,
    duration: 0.7,
    ease: 'power1.out',
    scrollTrigger: {
      trigger: item, // Use the next item as the trigger
      start: '0% 70%',
      toggleActions: 'play reverse play reverse',
      scrub: false,
    },
  })
  const layoutIllustrations = item.querySelectorAll('.grid-list3_item')
  gsap.to(layoutIllustrations, {
    opacity: 1,
    y: 0,
    scale: 1,
    rotate: 0,
    duration: 0.7,
    stagger: 0.1,
    ease: 'back.out(1.7)',
    scrollTrigger: {
      trigger: item,
      start: '0% 70%',
      toggleActions: 'play reverse play reverse',
      scrub: false,
    },
  })
})

gsap.from('#line1', {
  height: '0rem',
  opacity: 0,
  duration: 0.7,
  scrollTrigger: {
    trigger: '#line-wrapper1',
    start: '0% 70%',
    end: () => '+=' + document.querySelector('#line-wrapper1').offsetHeight, // Dynamically calculate the height
    scrub: 1,
  },
})

gsap.from('#line2', {
  height: '0rem',
  opacity: 0,
  duration: 0.7,
  scrollTrigger: {
    trigger: '#line-wrapper2',
    start: '0% 70%',
    end: () => '+=' + document.querySelector('#line-wrapper2').offsetHeight, // Dynamically calculate the height
    scrub: 1,
  },
})

gsap.fromTo(
  '.animated-line_animation',
  { y: -200, duration: 3, opacity: 0 },
  {
    y: 200,
    opacity: 1,
    repeat: -1,
    duration: 3,
    stagger: 0.2,
  }
)
